
















import { Mixins, Component } from 'vue-property-decorator'
import { SingpassLoginQRMixin } from './SingpassLoginQRMixin'

@Component
export default class Login extends Mixins(SingpassLoginQRMixin) {
}
